import { HttpClient } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ErrorService extends ErrorHandler {

  constructor(private http: HttpClient) {
    super()
  }

  override async handleError(error) {
    if (this.skipErrorNotification(error)) {
      window.dispatchEvent(new CustomEvent('SCANNER-ERROR'));
      (window as any).SCANNER_ERROR = true
      console.log("Error handling skipped QR scanner")
      return;
    }

    // ChunkLoadError - lazy loaded chunk failed (usually after new deployment)
    if (error?.message?.includes('ChunkLoadError') || error?.rejection?.message?.includes('Loading chunk')) {
      const lastReload = sessionStorage.getItem('chunkErrorReload');
      const now = Date.now();
      // Only reload if last reload was more than 10 seconds ago (prevents infinite loop)
      if (!lastReload || now - parseInt(lastReload) > 10000) {
        console.log("ChunkLoadError detected, reloading page...");
        sessionStorage.setItem('chunkErrorReload', now.toString());
        window.location.reload();
        return;
      }
      console.log("ChunkLoadError detected, but already reloaded recently - not reloading again");
    }

    super.handleError(error)
    error = {
      verze_klient: environment.version,
      message: error.message,
      stack: error.stack,
      hideLoader: true
    }
    this.http.post(`${environment.apiUrl}errorJs`, error).toPromise()
  }



  skipErrorNotification(error: any): boolean {
    // Error: Uncaught (in promise): UnknownError: setOptions failed - https://github.com/zxing-js/ngx-scanner/issues/297#issuecomment-621782384
    if (`${error.rejection?.message}`.includes("setOptions failed")) return true;
    else if (`${error.rejection?.message}`.includes("setPhotoOptions failed")) return true;
    else if (`${error.rejection?.message}`.includes("Track has ended")) return true;
    else if (`${error.rejection?.message}`.includes("The associated Track is in an invalid state")) return true;
    else if (`${error.rejection?.message}`.includes("This browser doesn't support the API's required to use the Firebase SDK")) return true;
    else if (`${error.rejection?.message}`.includes("evaluating 'navigator.serviceWorker.addEventListener'")) return true;
    else return false;
  }
}
